const MenuList = [
  {
    menuType: "Beverages",
    menuImage: "/images/menu/Beverages.svg",
    mainMenu: [
      {
        mainMenuName: "Juices",
        subMenu: ["Watermelon Juice", "Grape Juice", "Sweet Lime", "Pineapple Juice", "Orange Juice", "Gooseberry Juice", "Butter Juice"],
      },
      {
        mainMenuName: "Milkshakes",
        subMenu: ["Banana Milk Shakes", "Chickoo Milk Shakes", "Muskmelon Milk Shakes", "Papaya Milk Shakes", "Apple Milk Shakes"],
      },
      {
        mainMenuName: "Health Juice",
        subMenu: ["Beat The Root", "Healthy Spinach", "Cucumber Cooler", "Crazy Carrot", "Tomato Juice", "ABC + Apple Beetroot Carrot", "Spinach Pineapple Apple"],
      },
      {
        mainMenuName: "Protien shake",
        subMenu: ["Muscle Blondie (Milk, Banana, Peanut Butter & Protein)", "Amazon Thunder (Milk, Chocolate, Banana & Protein)", "Papaya Pleasure (Milk, Papaya & Protein)", "Melon Mayhem (Milk, Muskmelon & Protein)"],
      },
      {
        mainMenuName: "Lassi",
        subMenu: ["Plain Lassi", "Mango Lassi", "Strawberry Lassi", "Dry Fruits Lassi"],
      },
    ],
  },
  {
    menuType: "Breakfast Items",
    menuImage: "/images/menu/Breakfast.svg",
    mainMenu: [
      {
        mainMenuName: "Cereals with fruits and honey",
        subMenu: ["Corn Flakes", "Muesli", "French Toast", "Chocos"],
      },
      {
        mainMenuName: "Egg to order Omelettes",
        subMenu: ["Bell Pepper & Olives Omelette", "Sunny Side Up Omelette", "Baby Corn Omelette", "Spinach Omelette", "Egg White Omelette", "Egg White & Mushroom Omelette", "Scrambled Egg", "Tomato Omelette", "Masala Omelette", "Cheese Omelette", "Chicken Omelette", "Spinach & Corn Omelette", "Chicken & Mushroom Omelette"],
      },
      {
        mainMenuName: "Maggie",
        subMenu: ["Mixed Vegetables Maggie", "Egg Maggie", "Chicken Maggie", "Corn Maggie", "Paneer Maggie", "Vegetables N Cheese Maggie", "Mushroom Maggie", "Plain Maggie", "Masala Maggie"],
      },
      {
        mainMenuName: "Breads and Spreads",
        subMenu: ["Peanut Butter Sandwich", "Peanut Butter & Banana Sandwich", "The Creamy Spinach Corn Sandwich", "The 3'c Corn (Cheese Chilli) Sandwich", "Baby Corn Masala Sandwich", "Nutella Sandwich", "Panner Tikka Sandwich", "Aloo Masala Sandwich", "Channa Masala Sandwich", "Pudina Cucumber Sandwich", "Simply Veggie Sandwich", "Corn Masala Sandwich", "Spinach Corn Sandwich", "Egg Sandwich", "The Egg Stra-ordinary Sandwich", "Bombay Chicken Sandwich", "Roasted Chicken Delight Sandwich", "Chicken Tikka Sandwich"],
      },
    ],
  },
  {
    menuType: "Main Course",
    menuImage: "/images/menu/Main-Courses.svg",
    mainMenu: [
      {
        mainMenuName: "Oriental Work",
        subMenu: ["Veg Fried Rice (Brown Rice)", "Egg Fried Rice (Brown Rice)", "Chicken Fried Rice (Brown Rice)", "Egg And Chicken", "Fried Rice (Brown Rice)"],
      },
      {
        mainMenuName: "Italian Delight pasta with Choice of Sauce",
        subMenu: ["Alfredo Sauce", "Arabiata Sauce", "Pesto Sauce", "Pink Sauce", "Vegetarian Pasta", "Non-vegetarian Pasta"],
      },
      {
        mainMenuName: "Rolls",
        subMenu: ["Paneer Roll", "Egg Roll", "Chicken Roll", "Egg Chicken Roll"],
      },
      {
        mainMenuName: "Tibetan Momos",
        subMenu: ["Vegetable", "Veg Cheese", "Paneer", "Chicken", "Chicken Cheese"],
      },
    ],
  },
  {
    menuType: "Lighter Fare",
    menuImage: "/images/menu/Lighter-Fare.svg",
    mainMenu: [
      {
        mainMenuName: "Cream and Frothed",
        subMenu: ["Vanilla Ice Shake", "Mango Ice Shake", "Strawberry Ice Shake", "Kesar Pista Ice Shake"],
      },
      {
        mainMenuName: "Soups",
        subMenu: ["Mix Veg Soup", "Sweet Corn Soup", "Baby Corn Soup", "Corn N Peas", "Hot N Sour Chicken Soup"],
      },
      {
        mainMenuName: "Salad weigh your salad",
        subMenu: ["Fruit Bowl", "Veg Salad", "Egg Salad", "Chicken Salad"],
      },
      {
        mainMenuName: "The wholesome salads",
        subMenu: ["Fresh Garden Green Salad", "Veg & Fruit Salad", "Egg White Salad", "Grilled Veggie With Cottage", "Cheese Salad", "Corn Salad", "Sprout Salad", "Smoked Chicken Salad"],
      },
    ],
  },
  {
    menuType: "Snacks & Fast Food",
    menuImage: "/images/menu/Snacks.svg",
    mainMenu: [
      {
        mainMenuName: "Crunchy Burgers",
        subMenu: ["Veg Burger", "Egg Burger", "Chicken Burger"],
      },
      {
        mainMenuName: "Chats",
        subMenu: ["Dhai Puri", "Papdi Chaat", "Bhel Puri", "Sav Puri", "Samosa Chaat"],
      },
    ],
  },
  {
    menuType: "Cakes & Treats",
    menuImage: "/images/menu/Cake.svg",
    mainMenu: [
      {
        mainMenuName: "Cakes",
        subMenu: ["Plain cake", "Wheat cake", "Carrot cake", "Banana cake", "Dates cake", "Nuts cake", "Honey cake", "Plum cake"],
      },
      {
        mainMenuName: "Flavours",
        subMenu: ["Vanilla", "Black Forest", "White Forest", "Butterscotch", "Chocolate", "Chocolate Truffle", "White Chocolate Truffle", "Spanish Delight", "Kitkat Truffle", "Pista Forest", "Mocha Coffee", "Orange", "Vancho", "Mango", "Choco Almond", "Tres Leche", "Red Velvet", "Coffee", "Caramel", "Nutty Bubble", "Choco Oreo", "Strawberry", "Pineapple", "Vanilla Toffee", "Green Velvet", "Blue Velvet", "Kitkat & Gems Cake", "German Black Forest", "Rafaello", "Blueberry", "Rasmalai", "Gulab Jamoon", "Rose Milk", "Ferrero Rocher"],
      },
      {
        mainMenuName: "Treats",
        subMenu: ["Cupcakes", "Mousse Cups", "Cakesicles", "Cake pops", "Cookies", "Jar Cakes", "Chocolates", "Heartsicles", "Brownie", "Donuts"],
      },
    ],
  },
];

export { MenuList };
